import Bars from "./components/Bars";
import Controls from "./components/Controls";

function App() {
  return (
    <>
      <h1>Sorting Algorithm Visualizer</h1>
      <Controls />
      <Bars />
    </>
  );
}

export default App;

